module.exports = __webpack_public_path__ + "img/gpt.efc60726.png";